export default {
  alt_logo: "{product} Logo",
  alt_watermark: "{company} Watermark",
  support: "support",
}
